import { render } from "./modal-topup.vue?vue&type=template&id=6e9d4828&ts=true"
import script from "./modal-topup.vue?vue&type=script&lang=ts"
export * from "./modal-topup.vue?vue&type=script&lang=ts"

import "./modal-topup.vue?vue&type=style&index=0&id=6e9d4828&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__